import {useEffect} from 'react'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsLayoutRoute} from '../routes/layout-route'
import {useMarkerCountsActions} from '../stores/layout-selectors'

/** Hydrates marker count data from the tabCounts route query into the LayoutStore's marker-counts slice. */
export function useHydrateMarkerCounts() {
  const {data: tabCounts} = useRouteQuery(pullRequestsLayoutRoute, 'tabCounts')
  const {hydrateMarkerCounts} = useMarkerCountsActions()

  useEffect(() => {
    if (tabCounts) {
      hydrateMarkerCounts({
        unresolvedConversationCount: tabCounts.unresolvedConversationCount,
        annotationsCount: tabCounts.annotationsCount,
      })
    }
  }, [tabCounts, hydrateMarkerCounts])
}
